import {
  SubTitle,
  SurpriseBubble,
  SurpriseSpinner,
  SurpriseSpinnerAnimation,
} from '../SurprisePerk.styles';

interface SurprisePerkAnimationProps {
  shouldAnimate: boolean;
  onAnimationEnd: () => void;
  subtitle?: string;
}

const SurprisePerkAnimation = ({
  subtitle,
  shouldAnimate,
  onAnimationEnd,
}: SurprisePerkAnimationProps) => (
  <>
    <SurpriseBubble>
      <SubTitle variant="h2">{subtitle}</SubTitle>
    </SurpriseBubble>
    <SurpriseSpinner onAnimationEnd={onAnimationEnd} aria-label="Surprise Spinner">
      <SurpriseSpinnerAnimation shouldAnimate={shouldAnimate} />
    </SurpriseSpinner>
  </>
);

export default SurprisePerkAnimation;
